import {LOADING_SET_INVISIBLE, LOADING_SET_VISIBLE} from "redux/constants/Loading";

export const setLoadingVisible = () => ({
    type: LOADING_SET_VISIBLE,
});

export const setLoadingInvisible = () => ({
    type: LOADING_SET_INVISIBLE,
});